import React from 'react'
import type { IBenefit } from '@/components/composed/landingBlocks/LandingBenefits/interfaces'
import type { IListItem } from '@/components/composed/landingBlocks/LandingListInformation/types'
import type { IFaqItem } from '@/types/IFaqItem'
import { messages } from './messages'

export enum EScrollEventBlockId {
  agroserviceOfferForm = 'agroserviceOfferForm',
}

export const LEARN_LIST: IListItem[] = [
  {
    list: [
      messages.learn.list.item1,
      messages.learn.list.item2,
      messages.learn.list.item3,
      messages.learn.list.item4,
      messages.learn.list.item5,
      messages.learn.list.item6,
    ],
  },
]

export const SOLUTION_LIST: IListItem[] = [
  {
    list: [messages.solution.list.item1, messages.solution.list.item2, messages.solution.list.item3],
  },
]

export const BENEFITS: IBenefit[] = [
  {
    icon: 'computer',
    description: messages.benefits.list.item1,
  },
  {
    icon: 'verified',
    description: messages.benefits.list.item2,
  },
  {
    icon: 'harvest',
    description: messages.benefits.list.item3,
  },
]

export const FAQ: IFaqItem[] = [
  {
    question: messages.faq.list.item1.question,
    answer: (
      <>
        <p>{messages.faq.list.item1.answer.p1}</p>
        <p>{messages.faq.list.item1.answer.p2}</p>
        <p>{messages.faq.list.item1.answer.p3}</p>
      </>
    ),
  },
  {
    question: messages.faq.list.item2.question,
    answer: (
      <>
        <p>{messages.faq.list.item2.answer.p1}</p>
        <p>{messages.faq.list.item2.answer.p2}</p>
      </>
    ),
  },
]
